import React, { MouseEvent } from 'react';
import classNames from 'classnames';

import styles from './ArrowButton.module.css';

export enum ArrowDirection {
  Up = 'Up',
  Down = 'Down',
  Left = 'Left',
  Right = 'Right',
}
interface Props {
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
  direction: ArrowDirection;
  hidden?: boolean;
  disabled?: boolean;
}

export function ArrowButton(props: Props) {
  const { onClick, direction, hidden, disabled } = props;

  const containerClasses = classNames(
    styles['arrow-container'],
    {
      [styles['arrow-container--hidden']]: hidden,
      [styles['arrow-container--disabled']]: disabled,
      [styles['arrow-container--up']]: direction === ArrowDirection.Up,
      [styles['arrow-container--down']]: direction === ArrowDirection.Down,
      [styles['arrow-container--left']]: direction === ArrowDirection.Left,
      [styles['arrow-container--right']]: direction === ArrowDirection.Right,
    }
  );

  const arrowClasses = classNames(
    styles['arrow'],
    {
      [styles['arrow--up']]: direction === ArrowDirection.Up,
      [styles['arrow--down']]: direction === ArrowDirection.Down,
      [styles['arrow--left']]: direction === ArrowDirection.Left,
      [styles['arrow--right']]: direction === ArrowDirection.Right,
    },
  )

  return (
    <div
      className={containerClasses}
      onClick={onClick}
    >
      <div className={arrowClasses} />
    </div>
  );
}
